import { NgModule } from '@angular/core';

import { MasterEdit1Actions } from './master-edit-1.actions';

@NgModule({
  providers: [
    MasterEdit1Actions
  ]
})
export class MasterEdit1ActionsModule {}
